import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: 'Overview', icon: '📊', path: '/overview' },
    { name: 'My Post', icon: '📝', path: '/my-post' },
    { name: 'Favourites', icon: '❤️', path: '/favourites' },
    { name: 'Adopt', icon: '🐕', path: '/adopt' },
    { name: 'Rehome', icon: '🏠', path: '/rehome' },
    { name: 'Message', icon: '💬', path: '/message' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button 
        className="sidebar-toggle"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        {isCollapsed ? '☰' : '✕'}
      </button>

      <nav className="sidebar-menu">
        {menuItems.map(item => (
          <button
            key={item.name}
            className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {!isCollapsed && <span className="sidebar-text">{item.name}</span>}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
